import AppCommandBar from 'app/AppCommandBar'
import { FlexSpinner } from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { StickyPane } from 'components/StickyPane'
import { useShowCommand } from 'hooks/useCommand'
import useSelection from 'hooks/useSelection'
import { UserRole } from 'model'
import * as React from 'react'
import { useRouter } from 'react-router5'
import { participantDetails } from './../ArchiveParticipantsByNameView/ArchiveParticipantByNameView'
import { useArchivedProvingsQuery } from './../ArchiveParticipantsByNameView/ArchiveReadProvings.generated'
import { ArchiveParticipantListByAccomodation } from './ArchiveParticipantListByAccomodation'

const ArchiveParticipantsByAccomodationListView: React.FunctionComponent =
  () => {
    const { loading, data, error } = useArchivedProvingsQuery()
    const router = useRouter()
    const showParticipant = React.useCallback(
      (participant: participantDetails) => {
        router.navigate('provings.details', {
          id: participant.provingId,
          page: 'participants',
        })
      },
      [router]
    )

    const [selection, selectedItems] = useSelection<participantDetails>({
      getKey: (item) => item!._id!,
    })
    useShowCommand(
      { name: 'proving', count: selectedItems.length },
      {
        priority: 20,
        onClick: () => showParticipant(selectedItems[0]),
      },
      [selectedItems]
    )
    const participantsDetailsList: participantDetails[] = []
    const archivedProvings =
      data && data.provings ? data.provings.filter((x) => !x._deleted) : []
    archivedProvings.forEach((proving) => {
      if (proving.participants) {
        proving.participants.forEach((participant) => {
          participantsDetailsList.push({
            ...participant,
            provingGround: proving.provingGround!.title,
            provingId: proving.id,
            provingTitle: proving.title,
          })
        })
      }
    })
    return (
      <FlexSpinner loading={loading} error={error}>
        <ArchiveParticipantListByAccomodation
          items={participantsDetailsList}
          onItemInvoked={showParticipant}
          selection={selection}
        />
      </FlexSpinner>
    )
  }

export const ArchiveParticipantsByAccomodationView: React.FC = () => (
  <>
    <ViewAuthorizer
      roles={[
        UserRole.SystemAdministrator,
        UserRole.ResourceManager,
        UserRole.Reader,
        UserRole.ServiceTeam,
        UserRole.ProvingOrganisation,
        UserRole.Maintenancehead,
      ]}
    >
      <StickyPane>
        <AppCommandBar />
        <ArchiveParticipantsByAccomodationListView />
      </StickyPane>
    </ViewAuthorizer>
  </>
)
